import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiSignup, apiMe } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = unknown/guest
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("sutra_token");
    if (!token) {
      setLoading(false);
      return;
    }
    apiMe()
      .then((d) => setUser(d.user))
      .catch(() => {
        localStorage.removeItem("sutra_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (username, password) => {
    const d = await apiLogin({ username, password });
    localStorage.setItem("sutra_token", d.token);
    setUser(d.user);
    return d.user;
  }, []);

  const signup = useCallback(async (body) => {
    const d = await apiSignup(body);
    localStorage.setItem("sutra_token", d.token);
    setUser(d.user);
    return d.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("sutra_token");
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) return { user: null, loading: false, login: async () => {}, signup: async () => {}, logout: () => {} };
  return ctx;
}
